import React, { useState } from 'react';
import { Modal, Button, Form, Message } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { useStateValue } from '../context/stateContext';
import { addNumber, logout } from '../context/actions';
import { filterTrackingNumberInput } from '../utility/inputFilter';
import { getApiErrorMessage, isUnauthorizedError } from '../utility/apiError';

const initialNumber = { name: '', number: '' };

const ModalNumbersAdd = ({ isOpen, handleClose, trackNumber }) => {
  const dispatch = useStateValue()[1];
  const [newNumber, setNewNumber] = useState(initialNumber);
  const [submitError, setSubmitError] = useState('');
  const [isSubmitting, setSubmitting] = useState(false);

  const handleChange = ({ target: { name, value } }) => {
    setSubmitError('');
    if (name === 'number') {
      value = filterTrackingNumberInput(value);
    }
    setNewNumber({
      ...newNumber,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    setSubmitError('');
    setSubmitting(true);

    try {
      dispatch(await addNumber(newNumber));
      setNewNumber(initialNumber);
      trackNumber(newNumber.number);
    } catch (error) {
      if (isUnauthorizedError(error)) {
        dispatch(logout());
        handleCloseModal();
      } else {
        setSubmitError(getApiErrorMessage(error, { context: 'savedNumbers' }));
      }
    } finally {
      setSubmitting(false);
    }
  };
  const handleCloseModal = () => {
    handleClose();
    setNewNumber(initialNumber);
    setSubmitError('');
  };

  const handleNumberError = (name) =>
    (name && name.length < 10) || (name && name.length > 19)
      ? 'Broj za praćenje mora imati između 10 i 19 znakova.'
      : false;
  const handleNumberNameError = (number) =>
    number && number.length < 3
      ? 'Naziv mora sadržati najmanje 3 znaka.'
      : false;

  return (
    <div>
      <Modal
        size="mini"
        dimmer="blurring"
        open={isOpen}
        onClose={handleCloseModal}
      >
        <Modal.Header>Dodaj novi broj za praćenje:</Modal.Header>
        <Modal.Content>
          <Form error={!!submitError}>
            <Form.Input
              error={handleNumberNameError(newNumber.name)}
              label="Naziv pošiljke"
              required
              name="name"
              placeholder="Naziv"
              value={newNumber.name}
              onChange={handleChange}
            />
            <Form.Input
              error={handleNumberError(newNumber.number)}
              label="Broj za praćenje"
              required
              name="number"
              placeholder="Broj"
              value={newNumber.number}
              onChange={handleChange}
            />
            {submitError && <Message error content={submitError} />}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={handleCloseModal}>
            {' '}
            Zatvori
          </Button>

          <Button
            disabled={
              isSubmitting ||
              !!handleNumberError(newNumber.number) ||
              !!handleNumberNameError(newNumber.name) ||
              !newNumber.name ||
              !newNumber.number
            }
            onClick={handleSubmit}
            type="submit"
            loading={isSubmitting}
          >
            {' '}
            Dodaj
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

ModalNumbersAdd.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  trackNumber: PropTypes.func,
};

export default ModalNumbersAdd;
